import React, { useContext } from 'react';
import { useHistory } from 'react-router-dom';
import { Typography, Table, TableBody, TableCell, TableRow, TableContainer, Paper, Container, IconButton } from '@mui/material';
import { NavMenu } from './NavMenu';
import RouteContext from '../contexts/RouteContext';
import StopsContext from '../contexts/StopsContext';
import { Link, Route, useRouteMatch } from 'react-router-dom';
import { ConnectionAwareBackButton } from './ConnectionStatusBlip';
//import RouteStopTestData from '../test_data/routeStopsTestData';
import TableChart from '@mui/icons-material/TableChart';


const RouteScreenHeader = (props) => {

    return (
        <NavMenu>
            <ConnectionAwareBackButton />
            <Typography variant='h5' sx={{ flexGrow: 1, textAlign: "center" }}>
                {props.title}
            </Typography>
            <Link to="/loadout">
                <IconButton sx={{ color: "white" }} size="large">
                    <TableChart />
                </IconButton>
            </Link>
        </NavMenu>
    );

};

function statusColor(fieldActivity){

    let statusColor;
    switch (fieldActivity.Status) {
        case 'COMPLETED':
            statusColor = '#1EB980';
            break;
        case 'PENDING':
            statusColor = '#FFCF44';
            break;
        case 'CANCELLED':
        case 'FA NOT FOUND':
            statusColor = '#808080';
            break;
        default:
            statusColor = '#FFFFFF';
    }

    //show the red FI status if still pending
    if ((fieldActivity.ForemanInvestigateFlag) && (fieldActivity.Status === 'PENDING')) {
        statusColor = '#FF6859';
    }

    return statusColor;
};

const StopsList = (props) => {

    const { stops } = useContext(StopsContext);
    const { url } = useRouteMatch();
    const history = useHistory();

    return (
        <Paper sx={{ width: '100%', marginTop: "20px", marginBottom: "25px" }}>
            <TableContainer>
                <Table aria-label="route stops listing" >
                    <TableBody>
                        {stops.map((fieldActivity) => (
                            <TableRow
                                style={{height: 65 }}
                                hover
                                key={fieldActivity.Id}
                                onClick={() => history.push(`${url}/${fieldActivity.FieldActivityId}`)}
                                id={fieldActivity.FieldActivityId}
                            >
                                <TableCell style={{backgroundColor: statusColor(fieldActivity), fontSize: '2rem', fontWeight: 'bolder', textAlign: 'center'}}>
                                    {fieldActivity.Sequence}
                                </TableCell>
                                <TableCell style={{fontSize: '1.5rem', paddingTop: 5, paddingBottom: 0}}>
                                    {fieldActivity.Address}
                                </TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>
        </Paper>
    );
};

const RouteListScreen = ({ match }) => {
    const { containerRoute } = useContext(RouteContext);
    const routeScreenTitle = `Route ${containerRoute.RouteNumber} - ${containerRoute.RouteDate}`;
    const { url } = useRouteMatch();

    return (
        <div>
            <Route exact path={url}>
                <div id="RouteScreen">
                    <RouteScreenHeader routeNumber={containerRoute.routeNumber} title={routeScreenTitle}/>
                    <Container maxWidth={false} style={{paddingLeft: 0, paddingRight:0, marginTop: 72}}>
                        <StopsList />
                    </Container>
                </div>
            </Route>
        </div>
    );
};

export default RouteListScreen;
